<template>
  <div class="container ta-left">
    <b-form>
      <h3 class="mt-5">Bottom border effects</h3>

      <!-- Left to right -->
      <b-form-group id="input-group-1" class="col-6">
        <b-form-input
          id="input-1"
          class="effect-1"
          type="text"
          required
          placeholder="Placeholder Text"
        ></b-form-input>
        <span class="focus-border"></span>
      </b-form-group>

      <!-- In-out -->
      <b-form-group id="input-group-2" class="col-6">
        <b-form-input
          id="input-2"
          class="effect-2"
          type="text"
          required
          placeholder="Placeholder Text"
        ></b-form-input>
        <span class="focus-border"></span>
      </b-form-group>

      <!-- Out-in -->
      <b-form-group id="input-group-3" class="col-6">
        <b-form-input
          id="input-3"
          class="effect-3"
          type="text"
          required
          placeholder="Placeholder Text"
        ></b-form-input>
        <span class="focus-border"></span>
      </b-form-group>

      <h3 class="mt-5 mb-4">Top left floating label effects</h3>

      <!-- Left to right -->
      <b-form-group id="input-group-4" class="col-6">
        <b-form-input
          id="input-4"
          v-model="demo.input4"
          class="effect-16"
          :class="demo.input4 ? 'has-content' : ''"
          type="text"
          required
        ></b-form-input>
        <label>Placeholder Text</label>
        <span class="focus-border"></span>
      </b-form-group>

      <!-- In-out -->
      <b-form-group id="input-group-5" class="col-6">
        <b-form-input
          id="input-5"
          v-model="demo.input5"
          class="effect-17"
          :class="demo.input5 ? 'has-content' : ''"
          type="text"
          required
        ></b-form-input>
        <label>Placeholder Text</label>
        <span class="focus-border"></span>
      </b-form-group>

      <!-- Out-in -->
      <b-form-group id="input-group-6" class="col-6">
        <b-form-input
          id="input-6"
          v-model="demo.input6"
          class="effect-18"
          :class="demo.input6 ? 'has-content' : ''"
          type="text"
          required
        ></b-form-input>
        <label>Placeholder Text</label>
        <span class="focus-border"></span>
      </b-form-group>

      <h3 class="mt-5 mb-4">Curved border with floating label effects</h3>

      <b-form-group id="input-group-10" class="col-6">
        <b-form-input
          id="input-10"
          v-model="demo.input10"
          class="bordered-curve effect-25"
          :class="demo.input10 ? 'has-content' : ''"
          type="text"
          required
        ></b-form-input>
        <label>Placeholder Text</label>
      </b-form-group>

      <h3 class="mt-5 mb-4">Border with floating label effects</h3>

      <b-form-group id="input-group-7" class="col-6">
        <div>
          <b-form-input
            id="input-7"
            v-model="demo.input7"
            class="bordered effect-19"
            :class="demo.input7 ? 'has-content' : ''"
            type="text"
            required
          ></b-form-input>
          <label>Placeholder Text</label>
          <span class="focus-border"><i></i></span>
        </div>
      </b-form-group>

      <b-form-group id="input-group-8" class="col-6">
        <b-form-input
          id="input-8"
          v-model="demo.input8"
          class="bordered effect-20"
          :class="demo.input8 ? 'has-content' : ''"
          type="text"
          required
        ></b-form-input>
        <label>Placeholder Text</label>
        <span class="focus-border"><i></i></span>
      </b-form-group>

      <b-form-group id="input-group-9" class="col-6">
        <b-form-input
          id="input-9"
          v-model="demo.input9"
          class="bordered effect-21"
          :class="demo.input9 ? 'has-content' : ''"
          type="text"
          required
        ></b-form-input>
        <label>Placeholder Text</label>
        <span class="focus-border"><i></i></span>
      </b-form-group>

      <h3 class="mt-5 mb-4">Border effects</h3>

      <b-form-group id="input-group-10" class="col-6">
        <b-form-input
          id="input-10"
          class="bordered effect-4"
          type="text"
          required
          placeholder="Placeholder Text"
        ></b-form-input>
        <span class="focus-border"><i></i></span>
      </b-form-group>

      <b-form-group id="input-group-11" class="col-6">
        <b-form-input
          id="input-11"
          class="bordered effect-5"
          type="text"
          required
          placeholder="Placeholder Text"
        ></b-form-input>
        <span class="focus-border"><i></i></span>
      </b-form-group>

      <b-form-group id="input-group-12" class="col-6">
        <b-form-input
          id="input-12"
          class="bordered effect-6"
          type="text"
          required
          placeholder="Placeholder Text"
        ></b-form-input>
        <span class="focus-border"><i></i></span>
      </b-form-group>

      <b-form-group id="input-group-11" class="col-6">
        <b-form-input
          id="input-11"
          class="bordered effect-7"
          type="text"
          required
          placeholder="Placeholder Text"
        ></b-form-input>
        <span class="focus-border"><i></i></span>
      </b-form-group>

      <b-form-group id="input-group-11" class="col-6">
        <b-form-input
          id="input-11"
          class="bordered effect-8"
          type="text"
          required
          placeholder="Placeholder Text"
        ></b-form-input>
        <span class="focus-border"><i></i></span>
      </b-form-group>

      <b-form-group id="input-group-11" class="col-6">
        <b-form-input
          id="input-11"
          class="bordered effect-9"
          type="text"
          required
          placeholder="Placeholder Text"
        ></b-form-input>
        <span class="focus-border"><i></i></span>
      </b-form-group>
    </b-form>

    <h3 class="mt-5 mb-3">Background Effects</h3>

    <div class="col-6">
      <input class="effect-10" type="text" placeholder="Placeholder Text" />
      <span class="focus-bg"></span>
    </div>
    <div class="col-6">
      <input class="effect-11" type="text" placeholder="Placeholder Text" />
      <span class="focus-bg"></span>
    </div>
    <div class="col-6">
      <input class="effect-12" type="text" placeholder="Placeholder Text" />
      <span class="focus-bg"></span>
    </div>
    <div class="col-6">
      <input class="effect-13" type="text" placeholder="Placeholder Text" />
      <span class="focus-bg"></span>
    </div>
    <div class="col-6">
      <input class="effect-14" type="text" placeholder="Placeholder Text" />
      <span class="focus-bg"></span>
    </div>
    <div class="col-6">
      <input class="effect-15" type="text" placeholder="Placeholder Text" />
      <span class="focus-bg"></span>
    </div>

    <div class="col-6 input-effect ta-left">
      <input class="effect-22" type="text" placeholder="" />
      <label>First Name</label>
      <span class="focus-bg"></span>
    </div>
    <div class="col-6 input-effect ta-left">
      <input class="effect-23" type="text" placeholder="" />
      <label>First Name</label>
      <span class="focus-bg"></span>
    </div>
    <div class="col-6 input-effect ta-left">
      <input class="effect-24" type="text" placeholder="" />
      <label>First Name</label>
      <span class="focus-bg"></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      demo: {
        input1: '',
        input2: '',
        input3: '',
        input4: '',
        input5: '',
        input6: '',
        input7: '',
        input8: '',
        input9: '',
        input10: '',
        input11: '',
        input12: ''
      }
    }
  }
}
</script>

<style scoped>
.input-container {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
</style>
